export const rhythmUnitOptions = [4, 8, 16] as const;

export type RhythmUnit = (typeof rhythmUnitOptions)[number];

export const RHYTHM_UNIT_DEFAULT: RhythmUnit = rhythmUnitOptions[0];
